import { Pill } from '#components/atoms/pill/Pill.tsx';
import type { AuditLog } from '#dn-types/audit-log.ts';
import { summarizeChangesStructured, type ChangePillVariant } from './summarize-changes.ts';
import styles from './AuditLogChangeSummary.module.css';

type Props = {
  log: AuditLog;
};

const VARIANT_MAP: Record<ChangePillVariant, 'default' | 'alert' | 'success'> = {
  added: 'default',
  removed: 'default',
  changed: 'default',
  identity: 'default',
};

export function AuditLogChangeSummary({ log }: Props) {
  const pills = summarizeChangesStructured(log);
  if (!pills) return null;
  return (
    <span className={styles.AuditLogChangeSummary}>
      {pills.map((pill) => (
        <Pill key={pill.label} variant={VARIANT_MAP[pill.variant]} size="small">
          {pill.label}
        </Pill>
      ))}
    </span>
  );
}
